module.exports = __webpack_public_path__ + "img/credit-card.0ea527a4.svg";